'use strict';

var coreUtilityAliases = require('../var/coreUtilityAliases');

var forEachProperty = coreUtilityAliases.forEachProperty;

function simpleMerge(target, source) {
  forEachProperty(source, function(val, key) {
    target[key] = val;
  });
  return target;
}

module.exports = simpleMerge;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/simpleMerge.js
// module id = 40
// module chunks = 0